export const pattern10Data = [
  {
    id: 1,
    koreanChunks: ["나는", "즐긴다", "독서하는 것을", "아침에"],
    englishChunks: ["I", "enjoy", "reading", "in the morning"],
    fullEnglish: "I enjoy reading in the morning.",
    explanation:
      "enjoy는 동명사를 목적어로 취하는 동사입니다. 'reading'은 동명사로 사용되었습니다.",
    additionalExplanation: "동명사는 간단합니다 ~ 하는 것으로 해석 합니다",
  },

  {
    id: 2,
    koreanChunks: [
      "CEO는",
      "즐긴다",
      "논의하는 것을",
      "새로운 비즈니스 전략을",
      "그의 팀과",
    ],
    englishChunks: [
      "The CEO",
      "enjoys",
      "discussing",
      "new business strategies",
      "with his team",
    ],
    fullEnglish:
      "The CEO enjoys discussing new business strategies with his team.",
    explanation:
      "enjoy는 동명사를 목적어로 취하는 동사입니다. 'discussing'은 동명사로 사용되었습니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "매니저는",
      "피했다",
      "언급하는 것을",
      "예산 삭감에 대해",
      "회의에서 ",
    ],
    englishChunks: [
      "The manager",
      "avoided",
      "mentioning",
      "the budget cuts",
      "in the meeting",
    ],
    fullEnglish:
      "The manager avoided mentioning the budget cuts in the meeting.",
    explanation:
      "avoid는 동명사를 목적어로 취하는 동사입니다. 'mentioning'은 동명사로 사용되었습니다.",
  },
  {
    id: 4,
    koreanChunks: ["제출해주실 수 있나요?", "보고서를", "금요일까지"],
    englishChunks: ["Would you mind submitting", "the report", "by Friday"],
    fullEnglish: "Would you mind submitting the report by Friday?",
    explanation:
      "'Would you mind' 다음에는 동명사가 옵니다. 'submitting'은 동명사로 사용되었습니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "그녀는",
      "제안했다",
      "도입할 것을",
      "새로운 워크플로우를",
      "향상시키기 위해",
      "효율성을",
    ],
    englishChunks: [
      "She",
      "suggested",
      "implementing",
      "a new workflow",
      "to improve",
      "efficiency",
    ],
    fullEnglish:
      "She suggested implementing a new workflow to improve efficiency.",
    explanation:
      "suggest는 동명사를 목적어로 취하는 동사입니다. 'implementing'은 동명사로 사용되었습니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "그 회사는",
      "고려하는 중이다",
      "확장하는 것을",
      "그회사의 사업을",
      "동남아시아로",
    ],
    englishChunks: [
      "The company",
      "is considering",
      "expanding",
      "its operations",
      "to Southeast Asia",
    ],
    fullEnglish:
      "The company is considering expanding its operations to Southeast Asia.",
    explanation:
      "consider는 동명사를 목적어로 취하는 동사입니다. 'expanding'은 동명사로 사용되었습니다.",
  },
  {
    id: 7,
    koreanChunks: ["그는", "인정했다", "실수를 했다는 것을", "재무 보고서에서"],
    englishChunks: [
      "He",
      "admitted",
      "making an error",
      "in the financial report",
    ],
    fullEnglish: "He admitted making an error in the financial report.",
    explanation:
      "admit은 동명사를 목적어로 취하는 동사입니다. 'making'은 동명사로 사용되었습니다.",
  },
  {
    id: 8,
    koreanChunks: ["이사는", "부인했다", "승인한 것을", "불필요한 지출을"],
    englishChunks: [
      "The director",
      "denied",
      "approving",
      "the unnecessary expenses",
    ],
    fullEnglish: "The director denied approving the unnecessary expenses.",
    explanation:
      "deny는 동명사를 목적어로 취하는 동사입니다. 'approving'은 동명사로 사용되었습니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "그녀는",
      "끝냈다",
      "준비하는 것을",
      "프레젠테이션을",
      "마감 직전에",
    ],
    englishChunks: [
      "She",
      "finished",
      "preparing",
      "the presentation",
      "just before the deadline",
    ],
    fullEnglish:
      "She finished preparing the presentation just before the deadline.",
    explanation:
      "finish는 동명사를 목적어로 취하는 동사입니다. 'preparing'은 동명사로 사용되었습니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "인사팀은",
      "연기했다",
      "면접하는 것을",
      "새로운 후보자를 ",
      "다음 주까지",
    ],
    englishChunks: [
      "The HR team",
      "postponed",
      "interviewing",
      "new candidates",
      "until next week",
    ],
    fullEnglish:
      "The HR team postponed interviewing new candidates until next week.",
    explanation:
      "postpone은 동명사를 목적어로 취하는 동사입니다. 'interviewing'은 동명사로 사용되었습니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "그 회사는",
      "계속하고 있다",
      "투자하는 것을",
      "연구 개발에",
    ],
    englishChunks: [
      "The company",
      "keeps",
      "investing",
      "in research and development",
    ],
    fullEnglish: "The company keeps investing in research and development.",
    explanation:
      "keep은 동명사를 목적어로 취하는 동사입니다. 'investing'은 동명사로 사용되었습니다.",
  },
  {
    id: 12,
    koreanChunks: [
      "그 정책은",
      "금지한다",
      "사용하는 것을",
      "개인 기기를",
      "직장에서",
    ],
    englishChunks: [
      "The policy",
      "prohibits",
      "using",
      "personal devices",
      "in the workplace",
    ],
    fullEnglish:
      "The policy prohibits using personal devices in the workplace.",
    explanation:
      "prohibit은 동명사를 목적어로 취하는 동사입니다. 'using'은 동명사로 사용되었습니다.",
  },
  {
    id: 13,
    koreanChunks: [
      "우리 조직은",
      "장려한다",
      "참여하는 것을",
      "자원봉사 프로그램에",
    ],
    englishChunks: [
      "Our organization",
      "encourages",
      "participating",
      "in volunteer programs",
    ],
    fullEnglish:
      "Our organization encourages participating in volunteer programs.",
    explanation:
      "encourage는 동명사를 목적어로 취하는 동사입니다. 'participating'은 동명사로 사용되었습니다.",
  },
  {
    id: 14,
    koreanChunks: [
      "그 회사는",
      "전념한다(전념된다X)",
      "제공하는 것에",
      "우수한 고객 서비스를",
    ],
    englishChunks: [
      "The company",
      "is committed",
      "to providing",
      "excellent customer service",
    ],
    fullEnglish:
      "The company is committed to providing excellent customer service.",
    explanation:
      "commit to는 동명사를 목적어로 취하는 표현입니다. 'providing'은 동명사로 사용되었습니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "서명하기 전에 계약서에,",
      "확인하십시오",
      "읽는 것을",
      "모든 조항을",
      "신중히",
    ],
    englishChunks: [
      "Before signing the contract,",
      "make sure",
      "to read",
      "all the terms",
      "carefully",
    ],
    fullEnglish:
      "Before signing the contract, make sure to read all the terms carefully.",
    explanation:
      "전치사 before 뒤에 동명사가 사용되었습니다. 'signing'은 동명사로 사용되었습니다.",
    additionalExplanation: "to부정사도 ~ 하는 것으로 해석합니다.",
  },
  {
    id: 16,
    koreanChunks: [
      "그 매니저는",
      "책임이 있다",
      "감독하는 것에",
      "새로운 프로젝트를",
    ],
    englishChunks: [
      "The manager",
      "is responsible",
      "for overseeing",
      "the new project",
    ],
    fullEnglish: "The manager is responsible for overseeing the new project.",
    explanation:
      "be responsible for는 동명사를 목적어로 취하는 표현입니다. 'overseeing'은 동명사로 사용되었습니다.",
  },
  {
    id: 17,
    koreanChunks: [
      "그는",
      "성공했다",
      "협상하는 데",
      "더 나은 계약을",
      "공급업체와",
    ],
    englishChunks: [
      "He",
      "succeeded",
      "in negotiating",
      "a better deal",
      "with the supplier",
    ],
    fullEnglish: "He succeeded in negotiating a better deal with the supplier.",
    explanation:
      "succeed in은 동명사를 목적어로 취하는 표현입니다. 'negotiating'은 동명사로 사용되었습니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "우리는 사과드립니다",
      "답변하지 못한 것에 대해",
      "귀하의 문의에",
      "더 빨리",
    ],
    englishChunks: [
      "We apologize",
      "for not responding",
      "to your inquiry",
      "sooner",
    ],
    fullEnglish: "We apologize for not responding to your inquiry sooner.",
    explanation:
      "apologize for는 동명사를 목적어로 취하는 표현입니다. 'responding'은 동명사로 사용되었습니다.",
  },
  {
    id: 19,
    koreanChunks: [
      "직원들은",
      "금지된다",
      "사용하는 것이",
      "개인 기기를",
      "근무 시간 동안",
    ],
    englishChunks: [
      "Employees",
      "are discouraged",
      "from using",
      "personal devices",
      "during work hours",
    ],
    fullEnglish:
      "Employees are discouraged from using personal devices during work hours.",
    explanation:
      "be discouraged from은 동명사를 목적어로 취하는 표현입니다. 'using'은 동명사로 사용되었습니다.",
  },
  {
    id: 20,
    koreanChunks: [
      "그 회사는",
      "이익을 얻는다",
      "투자 하는것으로부터",
      "직원 교육 프로그램에",
    ],
    englishChunks: [
      "The company",
      "benefits",
      "from investing",
      "in employee training programs",
    ],
    fullEnglish:
      "The company benefits from investing in employee training programs.",
    explanation:
      "benefit from은 동명사를 목적어로 취하는 표현입니다. 'investing'은 동명사로 사용되었습니다.",
  },
  {
    id: 21,
    koreanChunks: [
      "비용 절감 외에도",
      "새로운 시스템은",
      "향상시킨다",
      "효율성을",
    ],
    englishChunks: [
      "In addition to reducing costs,",
      "the new system",
      "improves",
      "efficiency",
    ],
    fullEnglish:
      "In addition to reducing costs, the new system improves efficiency.",
    explanation:
      "in addition to는 동명사를 목적어로 취하는 표현입니다. 'reducing'은 동명사로 사용되었습니다.",
  },
  {
    id: 22,
    koreanChunks: ["의미가 없다", "논쟁하는것에 있어서", "수정된 정책에 대해"],
    englishChunks: [
      "There is no point",
      "in arguing",
      "about the revised policy",
    ],
    fullEnglish: "There is no point in arguing about the revised policy.",
    explanation:
      "there is no point in은 동명사를 목적어로 취하는 표현입니다. 'arguing'은 동명사로 사용되었습니다.",
  },
  {
    id: 23,
    koreanChunks: ["마케팅 팀은", "집중한다", "높이는 데", "브랜드 인지도를"],
    englishChunks: [
      "The marketing team",
      "is focused",
      "on increasing",
      "brand awareness",
    ],
    fullEnglish: "The marketing team is focused on increasing brand awareness.",
    explanation:
      "be focused on은 동명사를 목적어로 취하는 표현입니다. 'increasing'은 동명사로 사용되었습니다.",
  },
];
